import React from 'react';
import Icon from '../../Icon';

export default ({ active, onClick }) => (
  <div
    onClick={onClick}
    className={`bot-says-checkbox ${active ? 'active' : ''}`}
  >
    <Icon
      iconType="star"
      className="bot-says-checkbox-icon"
      maxTooltipWidth={250}
      tooltip="<strong>Star this entity</strong> <br/>By doing this, the bot will give the “final bot reply” only if the user gives a value for this entity.<br/> Until then, the bot will keep on asking the same question."
    />
  </div>
);
